exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-suggestions--empty .ebx-clear-history{display:none}", ""]);
